import React from "react";
import AsiaPayoutOrchestrator from "../../shared/AsiaPayoutOrchestrator";
import { indiaConfig } from "./config";

const IndiaPayout: React.FC = () => {
  return <AsiaPayoutOrchestrator config={indiaConfig} />;
};

export default IndiaPayout;
